<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" app :permanent="windowWidth >= 1280">
      <v-list-item class="pa-4">
        <v-avatar size="40" class="mr-3">
          <v-img src="https://cdn.leeshisi.cn/sunosong/1724133623859.jpg"></v-img>
        </v-avatar>
        <v-list-item-title class="text-h6">管理后台</v-list-item-title>
      </v-list-item>
      <v-divider></v-divider>
      <v-list density="compact" nav>
        <v-list-item
          v-for="item in navItems"
          :key="item.path"
          :prepend-icon="item.icon"
          :title="item.title"
          :to="item.path"
          rounded="xl"
        ></v-list-item>
      </v-list>
      <template v-slot:append>
        <div class="pa-4">
          <v-btn block variant="outlined" color="red" @click="logout">
            <v-icon start>mdi-logout</v-icon>退出登录
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar app density="compact" v-if="windowWidth < 1280">
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>管理后台</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="logout"><v-icon>mdi-logout</v-icon></v-btn>
    </v-app-bar>

    <v-main>
      <v-container fluid class="pa-6">
        <router-view />
      </v-container>
    </v-main>

    <v-snackbar v-model="snackbar" :timeout="2000" color="white">
      <p>{{ snackbarText }}</p>
      <template v-slot:actions>
        <v-btn color="pink" variant="text" @click="snackbar = false">关闭</v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
export default {
  name: 'AdminLayout',
  data() {
    return {
      drawer: true,
      windowWidth: window.innerWidth,
      snackbar: false,
      snackbarText: '',
      navItems: [
        { title: '仪表盘', icon: 'mdi-view-dashboard', path: '/lss/admin/dashboard' },
        { title: '用户管理', icon: 'mdi-account-group', path: '/lss/admin/users' },
        { title: '歌曲管理', icon: 'mdi-music', path: '/lss/admin/songs' },
        { title: '账号管理', icon: 'mdi-key', path: '/lss/admin/accounts' },
        { title: '任务管理', icon: 'mdi-clipboard-text', path: '/lss/admin/tasks' },
        { title: '行为分析', icon: 'mdi-chart-bar', path: '/lss/admin/analytics' },
      ]
    }
  },
  mounted() {
    window.addEventListener('resize', this.updateWindowDimensions);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  },
  methods: {
    updateWindowDimensions() {
      this.windowWidth = window.innerWidth;
    },
    logout() {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminUser');
      this.$router.push('/lss/admin/login');
    }
  }
}
</script>
